import { FileUploader } from '@partful/features/file-uploader/FileUploader';
import { SalesBOMFormSchema } from '@partful/pages/create-product/sales-bom/lib/SalesBOMFormSchema';
import { useTenant } from '@providers/Tenant';
import { postSBOM, postSBOMIngest } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useInvalidateQueries } from 'src/v2/shared/lib/hooks/useInvalidateQueries';
import { useUploadFile } from 'src/v2/shared/lib/hooks/useUploadFile';

interface UpdateSalesBOMFormProps {
  onSalesBOMUploadedSuccessfully: () => Promise<void>;
  configurationPID: string;
}
export function UpdateSalesBOMForm({ onSalesBOMUploadedSuccessfully, configurationPID }: UpdateSalesBOMFormProps) {
  const { accountId } = useTenant();
  const { invalidateContentProcessingJobsQueries } = useInvalidateQueries();

  const { mutateAsync: uploadFile } = useUploadFile();
  const { mutateAsync: createSalesBOMJob } = useMutation(
    ['createSalesBOMJob'],
    () => postSBOM(configurationPID!, accountId),
    {
      onSuccess: async () => {
        await invalidateContentProcessingJobsQueries();
      },
    }
  );

  const onSubmit = useCallback(
    async (data: SalesBOMFormSchema): Promise<void> => {
      const { file } = data;

      const { uploadURL, runID: sbomRunID } = await createSalesBOMJob();

      await uploadFile({ file, uploadURL });
      await postSBOMIngest(accountId, sbomRunID, { configurationPID: configurationPID! });
      await onSalesBOMUploadedSuccessfully();
    },
    [createSalesBOMJob, uploadFile, accountId, configurationPID, onSalesBOMUploadedSuccessfully]
  );

  return <FileUploader submitHandler={onSubmit} />;
}
